/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import moment, { Moment } from 'moment'
import React from 'react'
import DatePicker from 'react-datepicker'

import i18n from 'live/services/i18n'

import { TimeSpanContainer, TimeInput, TimeSelectList } from './styles'

interface IProps {
    startDate: Moment
    endDate: Moment
    setStartDate: (startDate: Moment) => void
    setEndDate: (endDate: Moment) => void
    maxDate?: Moment
    minDate?: Moment
}

export const TimeSpan: React.FC<IProps> = ({ startDate, endDate, setStartDate, setEndDate, minDate, maxDate }) => {
    const handleChangeDate = (dates: Date | [Date, Date], event: React.SyntheticEvent<any, Event>): void => {
        const insideDateStart = moment(new Date(dates as Date)).set({ hours: 0, minutes: 0, seconds: 0 })
        const insideDateEnd = moment(new Date(dates as Date)).set({ hours: 23, minutes: 59, seconds: 59 })
        if (!startDate) {
            setStartDate(insideDateStart)
        }
        if (!endDate) {
            setEndDate(insideDateEnd)
        }

        if (moment(dates as Date).isBefore(startDate)) {
            setStartDate(insideDateStart)
        }

        if (moment(dates as Date).isAfter(endDate)) {
            setEndDate(insideDateEnd)
        }

        if (moment(dates as Date).isBetween(startDate, endDate)) {
            setStartDate(insideDateStart)
            setEndDate(insideDateEnd)
        }

        if (
            (moment(dates as Date).isSame(startDate) || moment(dates as Date).isSame(startDate)) &&
            (!moment(dates as Date).isSame(startDate) || !moment(dates as Date).isSame(startDate))
        ) {
            setStartDate(insideDateStart)
            setEndDate(insideDateEnd)
        }
    }

    const handleChangeMinutes = (
        e: React.ChangeEvent<HTMLInputElement>,
        dateToChange: moment.Moment
    ): moment.Moment => {
        let number = Number.parseInt(e.target.value)
        if (isNaN(number)) {
            number = 0
        }
        if (number > 59) {
            number = 59
        }

        return moment(dateToChange).set('minutes', number)
    }

    const handleChangeHours = (e: React.ChangeEvent<HTMLInputElement>, dateToChange: moment.Moment): moment.Moment => {
        let number = Number.parseInt(e.target.value)
        if (isNaN(number)) {
            number = 0
        }
        if (number > 23) {
            number = 23
        }

        return moment(dateToChange).set('hours', number)
    }

    const handleChangeStartDateHours = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const newDate = handleChangeHours(e, startDate)
        setStartDate(newDate)
    }
    const handleChangeStartDateMinutes = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const newDate = handleChangeMinutes(e, startDate)
        setStartDate(newDate)
    }

    const handleChangeEndDateHours = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const newDate = handleChangeHours(e, endDate)
        setEndDate(newDate)
    }
    const handleChangeEndDateMinutes = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const newDate = handleChangeMinutes(e, endDate)
        setEndDate(newDate)
    }

    interface ICustomHeaderParams {
        date: Date
        changeYear(year: number): void
        changeMonth(month: number): void
        customHeaderCount: number
        decreaseMonth(): void
        increaseMonth(): void
        prevMonthButtonDisabled: boolean
        nextMonthButtonDisabled: boolean
        decreaseYear(): void
        increaseYear(): void
        prevYearButtonDisabled: boolean
        nextYearButtonDisabled: boolean
    }

    const renderCustomHeader = (params: ICustomHeaderParams): React.ReactNode => {
        const {
            date,
            prevYearButtonDisabled,
            decreaseMonth,
            prevMonthButtonDisabled,
            changeYear,
            increaseMonth,
            nextMonthButtonDisabled,
            nextYearButtonDisabled
        } = params

        return (
            <div
                style={{
                    margin: '0px 10px 10px 10px',
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}
            >
                <div style={{ maxWidth: 200, margin: '0 auto' }}>
                    <button
                        className="date-pass-buttom"
                        onClick={() => {
                            const tempDate = new Date(date)
                            const year = tempDate.getFullYear()
                            changeYear(year - 1)
                        }}
                        disabled={prevYearButtonDisabled}
                    >
                        {'<<'}
                    </button>
                    <button className="date-pass-buttom" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                        {'<'}
                    </button>

                    <span className="calendar-month-year">{moment(date).format('MMMM YYYY')}</span>

                    <button className="date-pass-buttom" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                        {'>'}
                    </button>
                    <button
                        className="date-pass-buttom"
                        onClick={() => {
                            const tempDate = new Date(date)
                            const year = tempDate.getFullYear()
                            changeYear(year + 1)
                        }}
                        disabled={nextYearButtonDisabled}
                    >
                        {'>>'}
                    </button>
                </div>
            </div>
        )
    }

    return (
        <TimeSpanContainer>
            <div className="title">
                <span>{i18n('TIMESPAN')}</span>
            </div>
            <DatePicker
                id={'custom-engineering-audit-date-picker'}
                inline
                // selected={selectedDate}
                selectsRange
                startDate={startDate as any}
                endDate={endDate as any}
                // dateFormat={displayFormat}
                onChange={handleChangeDate}
                nextYearButtonLabel="ASD"
                previousYearButtonLabel="DSA"
                renderCustomHeader={renderCustomHeader}
                maxDate={maxDate as any}
                minDate={minDate as any}
            />

            <TimeInput>
                <div className="start-control">
                    <span>{i18n('timespan_start')}</span>
                    <input
                        className="input"
                        type="text"
                        maxLength={10}
                        placeholder={i18n('YYYY/MM/DD')}
                        value={(startDate as Moment)?.format('YYYY/MM/DD')}
                        readOnly
                    />
                    <div className="hours-row">
                        <input
                            className="input input-hour"
                            type="number"
                            maxLength={2}
                            min={0}
                            max={23}
                            placeholder="HH"
                            value={(startDate as Moment)?.format('HH')}
                            onChange={handleChangeStartDateHours}
                            disabled={!startDate}
                        />
                        <input
                            className="input input-hour"
                            type="number"
                            maxLength={2}
                            min={0}
                            max={59}
                            placeholder="mm"
                            value={(startDate as Moment)?.format('mm')}
                            onChange={handleChangeStartDateMinutes}
                            disabled={!startDate}
                        />
                    </div>
                </div>
                <div className="space">
                    <div className="line"></div>
                    <span className="to">{i18n('to')}</span>
                    <div className="line"></div>
                </div>
                <div className="start-control">
                    <span>{i18n('timespan_end')}</span>
                    <input
                        className="input"
                        type="text"
                        maxLength={10}
                        placeholder={i18n('YYYY/MM/DD')}
                        value={(endDate as Moment)?.format('YYYY/MM/DD').toString()}
                        readOnly
                    />
                    <div className="hours-row">
                        <input
                            className="input input-hour"
                            type="number"
                            maxLength={2}
                            min={0}
                            max={23}
                            placeholder="HH"
                            value={(endDate as Moment)?.format('HH')}
                            onChange={handleChangeEndDateHours}
                            disabled={!endDate}
                        />
                        <input
                            className="input input-hour"
                            type="number"
                            maxLength={2}
                            min={0}
                            max={59}
                            placeholder="mm"
                            value={(endDate as Moment)?.format('mm')}
                            onChange={handleChangeEndDateMinutes}
                            disabled={!endDate}
                        />
                    </div>
                </div>
            </TimeInput>
            <TimeSelectList>
                <div className="timeControl">
                    <button
                        onClick={() => {
                            setEndDate(moment().subtract(1, 'days').set({ hours: 23, minutes: 59, seconds: 59 }))
                            setStartDate(moment().subtract(1, 'days').set({ hours: 0, minutes: 0, seconds: 0 }))
                        }}
                    >
                        {i18n('Yesterday')}
                    </button>
                    <button
                        onClick={() => {
                            setEndDate(moment())
                            setStartDate(moment().subtract(24, 'hours'))
                        }}
                    >
                        {i18n('Last 24 hours')}
                    </button>
                    <button
                        onClick={() => {
                            setEndDate(moment())
                            setStartDate(moment().subtract(7, 'days'))
                        }}
                    >
                        {i18n('Last week')}
                    </button>
                    <button
                        onClick={() => {
                            setEndDate(moment())
                            setStartDate(moment().subtract(15, 'days'))
                        }}
                    >
                        {i18n('Last 15 days')}
                    </button>
                </div>
                <div className="timeControl">
                    <button
                        onClick={() => {
                            setEndDate(moment())
                            setStartDate(moment().subtract(1, 'months'))
                        }}
                    >
                        {i18n('Last month')}
                    </button>
                    <button
                        onClick={() => {
                            setEndDate(moment())
                            setStartDate(moment().subtract(3, 'months'))
                        }}
                    >
                        {i18n('Last quarter')}
                    </button>
                    <button
                        onClick={() => {
                            setEndDate(moment())
                            setStartDate(moment().subtract(6, 'months'))
                        }}
                    >
                        {i18n('Last semester')}
                    </button>
                    <button
                        onClick={() => {
                            setEndDate(moment())
                            setStartDate(moment().subtract(1, 'years'))
                        }}
                    >
                        {i18n('Last year')}
                    </button>
                </div>
            </TimeSelectList>
        </TimeSpanContainer>
    )
}
